import insights from './insights.generated.json';

export const INSIGHTS = insights;

export default INSIGHTS;
